import React, { useState, useEffect, useCallback } from 'react';
import { Row, Col, Form } from 'antd';
import PropTypes from 'prop-types';
import { Clients, Territory, Family, Products, Years } from 'RootModule/catalogs';
import { connect } from 'react-redux';
import { querySave, queryClean } from 'Domains/TradeAgreements/redux/actions/query';
import { setCurrentView } from 'Domains/TradeAgreements/redux/actions/views';
import { ResetButton } from 'common/components';
import { cleanTopFilters } from '../../redux/actions/filters';
import { cleanInfo } from '../../redux/actions/info';
import {
  cleanInfoForAgreement,
  clientSelected,
  territorySelected,
} from '../../redux/actions/infoForAgreement';
import { cleanIndicators } from 'Domains/TradeAgreements/redux/actions/indicators';
import useWasRendered from '../../hooks/useWasRendered';
import useFilters from '../../hooks/useFilters';
import ActionsGroup from 'Domains/TradeAgreements/components/ActionsGroup';
import { processStepIdEnum, roleIdEnum } from 'common/models/enums';
import { getDaysLeftRequest } from 'Domains/TradeAgreements/redux/actions/registerTrade';
import {
  setClientKey,
  setCurrentClientData,
} from 'Domains/TradeAgreements/redux/actions/clientKey';
import ReviewActionsContainer from '../ReviewActionsContainer/ReviewActionsContainer';
import SecondLevelValidation from '../SecondLevelValidation';
import SegmentBusinessRules from 'RootModule/catalogs/SegmentBusinessRules';
import useUser from 'hooks/useUser';
import { RoleAccessControl } from 'Domains/TradeAgreements/common/accessControllers';
import { FaUpload } from 'react-icons/fa';
import { Link } from 'react-router-dom/cjs/react-router-dom';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';

const layoutFilters = {
  xs: 8,
  sm: 8,
  md: 8,
  lg: 4,
  xl: 4,
};
const {
  GENERATE_TRADE_AGREEMENT,
  VALIDITY_PROCESS,
  UPLOAD_TRADE_AGREEMENT,
  TRADE_AGREEMENT_ADJUST,
} = processStepIdEnum;

function TopFiltersNationalClients(props) {
  const {
    querySave: saveQuery,
    setCurrentView: setView,
    queryClean: cleanQuery,
    cleanTopFilters: cleanFilters,
    cleanInfo: infoClean,
    cleanInfoForAgreement: cleanAgreement,
    clientSelected: setClientSelected,
    cleanIndicators: indicatorsClean,
    onChangeActiveComponent,
    isNational,
    territorySelected: setTerritorySelected,
    getDaysLeftRequest: getDaysLeft,
    clientCatalogs,
    query,
    setClientKey: clientKeySet,
    setCurrentClientData: currentClientDataSet,
  } = props;
  const user = useUser();
  const { wasRendered, setWasRendered } = useWasRendered();
  const [form] = Form.useForm();
  const [disabledFilters, setDisabledFilters] = useState({});
  const [allowRequest, setAllowRequests] = useState({});
  const [requestParamsSubscription, setRequestParamsSubscription] = useState({});
  const location = useLocation();
  const [locationKey, setLocationKey] = useState(location.key);
  const cleanAllFilters = useCallback(() => {
    cleanFilters();
  }, [cleanFilters]);

  useEffect(() => {
    if (!wasRendered.current) {
      saveQuery({ state: 'idle', showBruteValue: true });
      cleanAllFilters();
      setWasRendered();
      getDaysLeft({ params: { processId: UPLOAD_TRADE_AGREEMENT } }); //6 días restantes
      getDaysLeft({ params: { processId: VALIDITY_PROCESS } }); //fecha de proceso
      getDaysLeft({ params: { processId: GENERATE_TRADE_AGREEMENT } });
      getDaysLeft({ params: { processId: TRADE_AGREEMENT_ADJUST } });
    }
  }, [saveQuery, wasRendered, setWasRendered, cleanAllFilters, getDaysLeft]);

  const {
    orchestrateFiltersChange,
    orchestrateFiltersReset,
    initialDisabledFilters,
    initialAllowRequest,
    initialRequestParamsSubscription,
  } = useFilters(isNational, false, query);

  useEffect(() => {
    if (initialDisabledFilters && initialAllowRequest && initialRequestParamsSubscription) {
      setDisabledFilters({ ...initialDisabledFilters });
      setAllowRequests({ ...initialAllowRequest });
      setRequestParamsSubscription({ ...initialRequestParamsSubscription });
      setWasRendered(true);
    }
  }, [
    initialAllowRequest,
    initialDisabledFilters,
    initialRequestParamsSubscription,
    wasRendered,
    setWasRendered,
  ]);

  const handleOnValuesChange = useCallback(
    ({ changedValues, _allValues }) => {
      const currentChange = Object.keys(changedValues)[0];
      const formValues = form.getFieldsValue();
      onChangeActiveComponent('trade-agreements');

      orchestrateFiltersChange({
        changedValues,
        currentChange,
        form,
        formValues,
        requestParamsSubscription,
        setAllowRequests,
        setClientSelected,
        setDisabledFilters,
        setRequestParamsSubscription,
        setTerritorySelected,
        isNational,
        clientCatalogs,
      });
      let selectedClient = null;
      if (clientCatalogs && clientCatalogs.length > 0) {
        selectedClient = clientCatalogs.find(
          (client) => client.key === form.getFieldValue('clientId')
        );
      }

      if (currentChange === 'businessRule' && !selectedClient?.isNational) {
        setView('clientId');
      } else if (
        selectedClient?.isNational &&
        currentChange !== 'businessRule' &&
        currentChange !== 'family' &&
        currentChange !== 'productId'
      ) {
        setView('subRegionId');
      } else if (currentChange === 'businessRule' && selectedClient?.isNational) {
        setView('clientId');
      } else {
        setView(currentChange);
      }
      //Sahring this part of the query with other components
      const queryValues = form.getFieldsValue();

      saveQuery({ ...queryValues, state: 'changed' });
    },
    [
      clientCatalogs,
      form,
      onChangeActiveComponent,
      orchestrateFiltersChange,
      requestParamsSubscription,
      setClientSelected,
      setTerritorySelected,
      isNational,
      setView,
      saveQuery,
    ]
  );

  const commonFilterProps = {
    allowClear: false,
  };

  const handleResetButton = useCallback(() => {
    form.resetFields();
    setDisabledFilters({
      ...initialDisabledFilters,
    });

    setAllowRequests({
      ...initialAllowRequest,
    });

    orchestrateFiltersReset({
      setDisabledFilters,
      setRequestParamsSubscription,
      setAllowRequests,
      form,
    });

    const formValues = form.getFieldsValue();
    cleanQuery({ state: 'idle', year: formValues.year, showBruteValue: true });
    cleanAgreement();
    cleanAllFilters();
    infoClean();
    indicatorsClean();
  }, [
    cleanAgreement,
    cleanAllFilters,
    cleanQuery,
    form,
    indicatorsClean,
    infoClean,
    initialAllowRequest,
    initialDisabledFilters,
    orchestrateFiltersReset,
  ]);

  useEffect(() => {
    if (location.key !== locationKey) {
      setLocationKey(location.key);
      handleResetButton();
    }
  }, [handleResetButton, location, locationKey]);

  const setAutomaticallyFirstOption = (options, filterName = 'nonde') => {
    if (options?.length > 0) {
      form.setFieldsValue({
        [filterName]: options[0]?.key,
      });
      const allValues = form.getFieldsValue();
      const changedValues = { [filterName]: options[0]?.key };
      handleOnValuesChange({ changedValues, allValues });
    }
  };

  const setAutomaticallyAnOption = (options, optionKey = 1, filterName = 'none') => {
    if (options?.length > 0) {
      const optionIndex = options.findIndex((option) => option?.value === optionKey);
      form.setFieldsValue({
        [filterName]: options[optionIndex]?.value ?? undefined,
      });
      const allValues = form.getFieldsValue();
      const changedValues = { [filterName]: options[optionIndex]?.value };
      handleOnValuesChange({ changedValues, allValues });
    }
  };
  const algo = (param) => {
    clientKeySet(param.clientId);
    currentClientDataSet(param);
  };
  const mustShowTerritory = () => {
    const getCurrentClientData = () => {
      if (!clientCatalogs || !form.getFieldValue().clientId) return null;
      return clientCatalogs.find((client) => client.key === form.getFieldValue().clientId);
    };
    const currentClient = getCurrentClientData();
    if (!currentClient) return false;
    return Boolean(currentClient.isNational);
  };

  return (
    <>
      <Form
        form={form}
        onValuesChange={(changedValues, allValues) => {
          handleOnValuesChange({ changedValues, allValues });
          algo(allValues);
        }}
        layout="horizontal"
        style={{ display: 'flex', justifyContent: 'start' }}
      >
        <Row>
          <Col {...layoutFilters}>
            <Years
              disabled={disabledFilters.year}
              askFromService={allowRequest.year ?? false}
              sourceId="Agreements"
              requestParams={requestParamsSubscription?.['year']}
              onSuccess={(options) => setAutomaticallyFirstOption(options, 'year')}
              {...commonFilterProps}
            />
          </Col>
          <Col {...layoutFilters}>
            <Clients
              disabled={disabledFilters.clientId}
              askFromService={allowRequest.clientId ?? false}
              sourceId="Agreements"
              requestParams={requestParamsSubscription?.['clientId']}
              {...commonFilterProps}
            />
          </Col>
          {mustShowTerritory() && (
            <Col {...layoutFilters}>
              <Territory
                disabled={disabledFilters.territoryId ?? null}
                askFromService={allowRequest.territoryId ?? null}
                sourceId="Agreements"
                requestParams={requestParamsSubscription?.['territoryId']}
                {...commonFilterProps}
              />
            </Col>
          )}
          <Col {...layoutFilters}>
            <SegmentBusinessRules
              disabled={disabledFilters.businessRule}
              askFromService={allowRequest.businessRule ?? false}
              sourceId="Agreements"
              requestParams={requestParamsSubscription?.['businessRule']}
              onSuccess={(options) => setAutomaticallyAnOption(options, '3', 'businessRule')}
              {...commonFilterProps}
            />
          </Col>
          <Col {...layoutFilters}>
            <Family
              disabled={disabledFilters.family}
              askFromService={allowRequest.family ?? false}
              sourceId="Agreements"
              requestParams={requestParamsSubscription?.['family']}
              {...commonFilterProps}
            />
          </Col>

          <Col {...layoutFilters}>
            <Products
              disabled={disabledFilters.productId}
              askFromService={allowRequest.productId ?? false}
              sourceId="Agreements"
              requestParams={requestParamsSubscription?.['productId']}
              {...commonFilterProps}
            />
          </Col>
        </Row>
      </Form>
      <Row gutter={32} justify="end">
        <Col>
          <ResetButton onClick={handleResetButton} />
        </Col>
        {user?.role?.roleId === roleIdEnum.SALES_AGENT && (
          <>
            <RoleAccessControl moduleKey="trade-agreements" page="register_trade-agreements">
              <Col>
                <Link to={'/trade-agreements/register/trade-agreements/'}>
                  <span style={{ fontSize: '1.75rem', color: '#00499A' }}>
                    <FaUpload />
                  </span>
                </Link>
              </Col>
            </RoleAccessControl>
          </>
        )}
        <Col>
          <ReviewActionsContainer />
        </Col>
        <Col style={{ textAlign: 'right' }}>
          <ActionsGroup />
          <SecondLevelValidation />
        </Col>
      </Row>
    </>
  );
}

TopFiltersNationalClients.propTypes = {
  intialValues: PropTypes.object,
};

TopFiltersNationalClients.defaultProps = {
  intialValues: {},
};

function mapStateToProps(state) {
  return {
    isLoadingReport: state?.SALES_CHALLENGE?.report?.isDownloading,
    isNational: state.TRADE_AGREEMENTS?.infoForAgreement?.clientInfo?.isNational,
    clientCatalogs: state?.APP?.catalogs?.clients?.data ?? false,
    query: state.TRADE_AGREEMENTS?.query,
    validityProcess: state.TRADE_AGREEMENTS?.registerTrade?.daysLeft?.data?.VALIDITY_PROCESS,
  };
}

export default connect(mapStateToProps, {
  querySave,
  setCurrentView,
  queryClean,
  cleanTopFilters,
  cleanInfo,
  cleanInfoForAgreement,
  cleanIndicators,
  clientSelected,
  territorySelected,
  getDaysLeftRequest,
  setClientKey,
  setCurrentClientData,
})(TopFiltersNationalClients);
